import BaseViewModel from "./BaseViewModel";

class UserInfoListViewModel extends BaseViewModel {

	typeId = "UserInfoList";

};

export default UserInfoListViewModel;
